// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30t4a","label":"styles_label__39JRp"};